import { render, staticRenderFns } from "./OutcomeEditor.vue?vue&type=template&id=590d9f92"
import script from "./OutcomeEditor.vue?vue&type=script&lang=js"
export * from "./OutcomeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports